export interface CurriculumPointDataType {
  label: string;
  title1: string;
  title2: string;
  imageSrc: string;
  description: string;
}

export const curriculumPointData: CurriculumPointDataType[] = [
  {
    label: 'POINT 1',
    title1: '국가공인 운전 강사의',
    title2: '운전면허교육 커리큘럼',
    imageSrc: '/images/recommend-class/common/point_img_01.png',
    description:
      '국가공인 운전 강사들이 연구한 자체 운전면허교육<br/>' +
      '커리큘럼을 통해 시험에 핵심적인 내용들만<br/>' +
      '체계적으로 지도합니다.',
  },
  {
    label: 'POINT 2',
    title1: '전국 모든 시험장 코스의',
    title2: '기능시험, 도로주행을 그대로',
    imageSrc: '/images/recommend-class/common/point_img_02.png',
    description:
      '전국 23개 운전면허시험장에서 실시하는<br/>' +
      '장내기능, 도로주행 시험 코스를 3D로 동일하게<br/>' +
      '구현하여 현실감 넘치는 연습이 가능합니다.',
  },
  {
    label: 'POINT 3',
    title1: '어려운 코스만 집중적으로',
    title2: '무한반복 연습',
    imageSrc: '/images/recommend-class/common/point_img_03.png',
    description:
      '시뮬레이터의 가장 큰 장점인 무한 반복 연습을 통해<br/>' +
      '운전면허시험장의 어려운 코스만 집중적으로 연습하여<br/>' +
      '효율적으로 학습하고 합격률을 극대화할 수 있어요.',
  },
  {
    label: 'POINT 4',
    title1: '다칠 일이 전혀 없는',
    title2: '안전한 운전연습',
    imageSrc: '/images/recommend-class/common/point_img_04.png',
    description:
      '운전연습 중 사고가 발생하더라도 운전시뮬레이션은<br/>' +
      '어떠한 물리적 충돌이나 피해가 없기 때문에<br/>' +
      '부모님들도 안심하고 자녀의 교육을 맡길 수 있어요',
  },
];

export const moCurriculumPointData: CurriculumPointDataType[] = [
  {
    label: 'POINT 1',
    title1: '국가공인 운전 강사의',
    title2: '운전면허교육 커리큘럼',
    imageSrc: '/images/recommend-class/common/point_img_01_m.png',
    description:
      '국가공인 운전 강사들이 연구한<br/>' +
      '자체 운전면허교육 커리큘럼을 통해<br/>' +
      '시험에 핵심적인 내용들만<br/>' +
      '체계적으로 지도합니다.',
  },
  {
    label: 'POINT 2',
    title1: '전국 모든 시험장 코스의',
    title2: '기능시험, 도로주행을 그대로',
    imageSrc: '/images/recommend-class/common/point_img_02_m.png',
    description:
      '전국 23개 운전면허시험장에서 <br/>' +
      '실시하는 장내기능, 도로주행 시험<br/>' +
      '코스를 3D로 동일하게 구현하여<br/>' +
      '현실감 넘치는 연습이 가능합니다.',
  },
  {
    label: 'POINT 3',
    title1: '어려운 코스만 집중적으로',
    title2: '무한반복 연습',
    imageSrc: '/images/recommend-class/common/point_img_03_m.png',
    description:
      '시뮬레이터의 가장 큰 장점인 무한 반복<br/>' +
      '연습을 통해 운전면허시험장의 어려운<br/>' +
      '코스만 집중적으로 연습하여 효율적으로<br/>' +
      '학습하고 합격률을 극대화할 수 있어요.',
  },
  {
    label: 'POINT 4',
    title1: '다칠 일이 전혀 없는',
    title2: '안전한 운전연습',
    imageSrc: '/images/recommend-class/common/point_img_04_m.png',
    description:
      '운전연습 중 사고가 발생하더라도<br/>' +
      '운전시뮬레이션은 어떠한 물리적 충돌이나<br/>' +
      '피해가 없기 때문에 부모님들도 안심하고<br/>' +
      '자녀의 교육을 맡길 수 있어요',
  },
];

export interface RecommendClassCautionsTextPart {
  text: string;
  bold?: boolean;
  color?: string;
}

export interface RecommendClassCautionsItem {
  parts: RecommendClassCautionsTextPart[];
}

export interface RecommendClassCautionsData {
  title: string;
  items: RecommendClassCautionsItem[];
}

// 커리큘럼 단계 데이터
export interface CurriculumStepItem {
  stepNumber: number;
  title: string;
  imageSrc: string;
  imageAlt: string;
  description: string;
  operations: string[];
  [key: string]: unknown; // StepItem과 호환되도록 인덱스 시그니처 추가
}
